var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import CtaButton from '../../../components/CtaButton';
import ImageSlider from '../../../components/ImageSlider';
import CreateCartItem from '../../../components/CreateCartItem';
import SizeSelector from './SizeSelector';
import { localizeUrl } from '../../../core/helpers/url-helper';
var ProductViewHero = /** @class */ (function (_super) {
    __extends(ProductViewHero, _super);
    function ProductViewHero() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductViewHero.prototype.render = function () {
        var _this = this;
        var _a;
        var translations = (_a = global.App.products.find(function (product) { return product.id === _this.props.item.id; })) === null || _a === void 0 ? void 0 : _a.translations;
        if (!translations) {
            return null;
        }
        return (React.createElement("div", { className: "c-product-view-hero" },
            React.createElement("div", { className: "c-product-view-hero__image" },
                React.createElement(ImageSlider, { images: this.props.images, modifier: ['product-view'] })),
            React.createElement("div", { className: "c-product-view-hero__content" },
                React.createElement("h1", { className: "c-title c-title--style8" }, translations[global.App.locale.locale].name),
                React.createElement("h2", { className: "c-title c-title--style5 h-color--pink-400" },
                    React.createElement(Trans, { i18nKey: "landing.products.item" + this.props.item.id + ".price" },
                        React.createElement("span", { className: "h-text-decoration--line-through" }))),
                React.createElement("p", { className: "h-margin-top--10 h-margin-top--md-20" },
                    React.createElement(Trans, { i18nKey: "product_view.item" + this.props.item.id + ".content1" },
                        React.createElement("br", null))),
                this.props.children,
                React.createElement("p", { className: "h-margin-top--10 h-margin-top--md-20" },
                    React.createElement(Trans, { i18nKey: "product_view.item" + this.props.item.id + ".content2" },
                        React.createElement("br", null))),
                this.props.sizes && this.props.sizeHandler && (React.createElement(SizeSelector, { sizes: this.props.sizes, sizeHandler: this.props.sizeHandler })),
                React.createElement("div", { className: "c-product-view-hero__button h-padding-top--15" }, this.renderCtaButton()))));
    };
    ProductViewHero.prototype.renderCtaButton = function () {
        if (this.props.cartItem.variants.length > 0) {
            return (React.createElement(CtaButton, { icon: "arrow-right", label: "button.start", modifier: ['yellow', 'lg', 'shadow', 'icon-right'], link: localizeUrl("/products/" + this.props.cartItem.slug + "/variants") }));
        }
        return (React.createElement(CreateCartItem, { item: this.props.cartItem },
            React.createElement(CtaButton, { icon: "arrow-right", label: "button.start", modifier: ['yellow', 'lg', 'shadow', 'icon-right'] })));
    };
    return ProductViewHero;
}(React.Component));
export default withTranslation()(ProductViewHero);
